import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tutorial-skeleton',
  templateUrl: './tutorial-skeleton.component.html',
  styleUrls: ['./tutorial-skeleton.component.scss'],
  standalone: true
})
export class TutorialSkeletonComponent {
  @Input() numberOfSkeletons = 5;

  skeletons() {
    return new Array(this.numberOfSkeletons);
  }
}
